export default "__VITE_ASSET__BXirquZw__"